import { createSlice } from "@reduxjs/toolkit";

const gptSlice = createSlice({
  name: "gpt",
  initialState: {
    showGptSearch: false,
    gptMovieNames:null, //Names of the movies suggested by GPT
    tmdbMovieList:null, //TMDB api results of the names by GPT
  },
  reducers:{
    toggleGptSearchView: (state)=>{
        state.showGptSearch =!state.showGptSearch;
    },
    addGptMovieResult: (state,action)=>{
      const {gptMovieNames, tmdbMovieList} = action.payload;
      state.gptMovieNames = gptMovieNames;
      state.tmdbMovieList = tmdbMovieList;
    },
    clearSuggestionPage:(state)=>{
      state.gptMovieNames = null;
      state.tmdbMovieList = null;
    }
  }
});

export const { toggleGptSearchView, addGptMovieResult, clearSuggestionPage } = gptSlice.actions;
export default gptSlice.reducer;